import {
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
  Text,
} from '@lightspeed/design-system-react'
import React, { FunctionComponent } from 'react'
import { T } from '@transifex/react'
import { $state } from '../../../../ng-compat/imports'
import { STATES } from '../../../../../../lib/routes'

interface ConfirmSaleWithPaymentsModalProps {
  close: () => void
}

export const ConfirmSaleWithPaymentsModal: FunctionComponent<ConfirmSaleWithPaymentsModalProps> = ({
  close,
}) => {
  const returnToSale = () => {
    close()
    $state.go(STATES.SALE)
  }

  return (
    <Modal onClose={close} size="small">
      <ModalHeader>
        <T _str="Please complete your previous sale" />
      </ModalHeader>
      <ModalContent>
        <Text tag="p">
          <T _str="You’ve taken payments on your previous sale, so that sale must be completed, saved or put on account or Layby" />
        </Text>
      </ModalContent>
      <ModalActions>
        <div className="vd-btn-group">
          <Button onClick={returnToSale}>
            <T _str="Return to Sale in Progress" />
          </Button>
        </div>
      </ModalActions>
    </Modal>
  )
}
